import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { makeBillingAddressString } from '@global/utils/lang';
import { PaybBillingAddress } from '@pages/SubscriptionDetails/types';

import { IBillingInfo, LOCALE_CODES } from '@global/types/types';
import { CountryService } from '@global/utils/CountryService';
import { store } from '@global/store/store';
import { RootState } from '@global/store/store';

interface IProps {
  disabled: boolean;
  toggleOpen: () => void;
  isShow: boolean;
  billingInfo: IBillingInfo;
}

export const BillingInfo: FC<IProps> = ({
  disabled,
  toggleOpen,
  isShow,
  billingInfo,
}) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language as LOCALE_CODES;
  const { country: countryState } = store.getState() as RootState;

  if (!billingInfo) return null;

  const country = billingInfo?.country?.iso2Code
    ? CountryService.getCountryByIsoCode(
        countryState.countries,
        billingInfo.country.iso2Code
      )
    : undefined;

  const paybBillingAddress: PaybBillingAddress | null = {
    line1: billingInfo?.addressOne,
    line2: billingInfo?.addressTwo,
    zip: billingInfo?.zip,
    city: billingInfo?.city,
    state: billingInfo?.state,
    country: {
      name: billingInfo?.country.name,
      numericCode: billingInfo?.country.numericCode,
      iso2Code: billingInfo?.country.iso2Code,
    },
  };

  const userInformationString = makeBillingAddressString(
    language,
    {
      zip: paybBillingAddress.zip,
      city: paybBillingAddress.city,
      state: paybBillingAddress.state,
    },
    country
  );

  return (
    <div className="sub-information__billing-container">
      <div className="sub-information__column">
        <span className="sub-information__text_black">{billingInfo?.name}</span>
        <span className="sub-information__text_black">{billingInfo?.tel}</span>
        <span className="sub-information__text_black">
          {paybBillingAddress.line1}
        </span>
        <span className="sub-information__text_black">
          {paybBillingAddress.line2}
        </span>
        <span className="sub-information__text_black">
          {userInformationString}
        </span>
        <span className="sub-information__text_black">
          {paybBillingAddress.country.name}
        </span>
      </div>

      <button
        className={`show-form-btn btn-toggle ${
          isShow ? 'btn-toggle__active' : ''
        }`}
        disabled={disabled}
        onClick={toggleOpen}
      >
        {t('subDetails.sub.billing.billingEditCta.btnText')}
      </button>
    </div>
  );
};
